import Svg from 'react-native-svg'

import {BRAND} from '#/lib/brand'
import {BrandMarkPaths} from '#/lib/brand/BrandMarkSvg'
import {type Props, useCommonSVGProps} from './common'

// The active brand's mark (cooey triangle / eagledrive tile / yeet vinyl).
// Single-path brands tint with the current color; fixed-palette brands render
// their own colors.
export function Mark(props: Props) {
  const {fill, size, style, gradient, ...rest} = useCommonSVGProps(props)

  return (
    <Svg
      fill="none"
      {...rest}
      viewBox={BRAND.markViewBox}
      width={size}
      height={size}
      style={[style]}>
      {gradient}
      <BrandMarkPaths fill={fill} />
    </Svg>
  )
}

export function Full(
  props: Omit<Props, 'fill' | 'size' | 'height'> & {
    markFill?: Props['fill']
    textFill?: Props['fill']
  },
) {
  // The "full" logo is just the brand mark (no wordmark).
  const {fill, size, style, gradient, ...rest} = useCommonSVGProps(props)

  return (
    <Svg
      fill="none"
      {...rest}
      viewBox={BRAND.markViewBox}
      width={size}
      height={size}
      style={[style]}>
      {gradient}
      <BrandMarkPaths fill={(props.markFill ?? fill) as string} />
    </Svg>
  )
}
